import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import AzureKeyVaultResourceDetailsView from "./AzureKeyVaultResourceDetailsView";

const AzureKeyVaultCertificateDetailsView = ({ entityData }) => {
  return (
    <AzureKeyVaultResourceDetailsView entityData={entityData}>
      <Box display="flex" flexDirection="column" gap={2}>
        {entityData?.azure_keyvault_certificate_data?.subject && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Certificate Subject</Typography>
            </Box>
            <Box ml={2} display="flex" alignItems="center" gap={0.5}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <TextIntegrationStyle
                  title=""
                  value={entityData.azure_keyvault_certificate_data.subject}
                />
              </Box>
            </Box>
          </Box>
        )}
        {entityData?.azure_keyvault_certificate_data?.issuer && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Certificate Issuer</Typography>
            </Box>
            <Box ml={2} display="flex" alignItems="center" gap={0.5}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <TextIntegrationStyle
                  title=""
                  value={
                    entityData.azure_keyvault_certificate_data.issuer === "Self"
                      ? "Self-signed certificate"
                      : entityData.azure_keyvault_certificate_data.issuer
                      ? "Certificate issued by non-integrated CA"
                      : "Certificate issued by integrated CA - " +
                        entityData.azure_keyvault_certificate_data.issuer
                  }
                />
              </Box>
            </Box>
          </Box>
        )}
        {entityData?.azure_keyvault_certificate_data?.serial_number && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Serial Number</Typography>
            </Box>
            <Box ml={2} display="flex" alignItems="center" gap={0.5}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <TextIntegrationStyle
                  title=""
                  value={
                    entityData.azure_keyvault_certificate_data.serial_number
                  }
                />
              </Box>
            </Box>
          </Box>
        )}
        {entityData?.azure_keyvault_certificate_data?.san_dns_names_list
          ?.length > 0 && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">
                Subject Alternative Names
              </Typography>
            </Box>
            <Box ml={2} display="flex" alignItems="center" gap={0.5}>
              <Box display="flex" flexDirection="column" gap={0.5}>
                {entityData.azure_keyvault_certificate_data.san_dns_names_list.map(
                  (dns_name, index) => (
                    <TextIntegrationStyle
                      key={index}
                      title={""}
                      value={dns_name}
                    />
                  )
                )}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </AzureKeyVaultResourceDetailsView>
  );
};

export default AzureKeyVaultCertificateDetailsView;
